import React from 'react';

const PostTags = () => {
  return (
    <div className="td-post-source-tags mx-10 md:mx-36 max-w-3xl py-4">
      <ul className="td-tags flex flex-wrap my-10">
        <li className="font-semibold">
        </li>
        <li>
          <a
            href="/blog/tag/internet-privacy/"
            className="inline-flex items-center justify-center mr-3 mb-3 px-6 py-1 bg-yellow-100 text-[#001d2f] rounded-full hover:bg-yellow-300 "
          >
            Featured
          </a>
        </li>
        <li>
          <a
            href="/blog/tag/social-media/"
            className="inline-flex items-center justify-center mr-3 mb-3 px-6 py-1 bg-yellow-100 text-[#001d2f] rounded-full hover:bg-yellow-300 "
          >
            Latest
          </a>
        </li>
      </ul>
    </div>
  );
};

export default PostTags;
